const commdity = {
    state: {
        query: {
            tab: 0,
        }
    },
    mutations: {
        changeTab(state,val) {
            state.query.tab = val
        }
    }
}

export default commdity;